import {useQuery} from "@tanstack/react-query";
import {SubscriptionService} from "../services/subscription-service";

export const useSubscription = () => {
    const queryInfo = useQuery({
        queryKey: ['subscription'],
        queryFn: async () => await SubscriptionService.active(),
    });

    return {
        ...queryInfo,
        get subscription() { return queryInfo.data; },
    };
};

export const useSubscriptionHistory = (id: string) => {
    const queryInfo = useQuery({
        queryKey: ['subscription', 'history', {id}],
        queryFn: async () => await SubscriptionService.history(id),
    });

    return {
        ...queryInfo,
        get history() { return queryInfo.data; },
    };
};